<template>
  <div class="col-md-12 h-90 w-100 overflow-y-scroll px-0">
    <b-overlay :show="loading">
      <table class="w-100 rounded">
        <thead class="fb-bg-primary" style="color:white;">
          <tr>
            <th>Estado</th>
            <th>Nombre</th>
            <th class="text-center">Tamaño</th>
            <th>Fecha Creación</th>
            <th>Propietario</th>
          </tr>
        </thead>
        <tbody id="folder-elements" v-if="!loadingElements">
          <!-- FOLDER ELEMENTS -->
          <rs-navigation-element
            v-for="element in folderElements"
            :element="element" :key="element.id"
            data-cy="folder"
          />
          <!-- FILE ELEMENTS -->
          <rs-navigation-element
            v-for="element in fileElements"
            :element="element" :key="element.id"
            data-cy="file"
          />
          <!-- EMPTY FOLDER MESSAGE -->
          <tr v-if="isEmptyFolder">
            <td colspan="5">
              <div class="d-flex justify-center m-5">
                <span>Ups! esta carpeta está vacía.</span>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <!-- SKELETON LOADER -->
          <tr v-if="loadingElements">
            <td class="opacity-0">.</td>
          </tr>
          <tr v-for="i in (loadingElements ? 5 : 0)" :key="i">
            <td class="px-2" v-for="i in 5" :key="i">
              <b-skeleton class="bg-grey-light w-100" animation="fade" />
            </td>
          </tr>
        </tbody>
      </table>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import RsNavigationElement from '@/febos/global/customDocuments/components/repository-selector/RSNavigationElement';

export default {
  name: 'rs-file-table',
  components: {
    RsNavigationElement,
  },
  computed: {
    ...mapGetters('DocManagement', [
      'loading',
    ]),
  },
  props: {
    folderElements: Array,
    fileElements: Array,
    isEmptyFolder: Boolean,
    loadingElements: Boolean
  }
};
</script>
<style lang="scss" scoped>
.drop-icon-holder {
  margin-top: 50px;
  margin-left: 50%;
  width: 50px;
  left: -25px;
  position: relative;
}

.drop-icon {
  font-size: 50px;
  color: #ccc;
}

.drag {
  border: dashed 2px #ddd;
  background-color: #eee !important;
}

.drag .help {
  text-align: center;
  margin-top: 30px;
  color: #1e1e1e;
}

.progress-content {
  display: inline-block;
}

.progress-content:first-child {
  vertical-align: sub;
}

.progress-wrapper {
  margin-top: 50px;
  text-align: center;
}

.fb-bg-primary {
  background-color: rgb(var(--vs-primary));
}

.toggle {
  height: 20vh !important;
  overflow: hidden;
}

.separator {
  display: inline-block;
  width: 20px;
}

#folder-elements {
  /* no eliminar! es por propositos de manejo de UI */
}
</style>
<style>
.h-90 {
  height: 90% !important;
}
</style>
